<template>
  <div>
    <img class="img-box" v-for="(img, index) in imgList" v-lazy="img" :key="index" />
  </div>
</template>
<script>
import { getImgList } from '@/api/eduPush'
export default {
  data () {
    return {
      imgList: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      const id = this.$route.query.id
      const requestData = {
        id: id
      }
      getImgList(requestData).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            this.imgList = res.data.result
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.img-box {
  display: block;
  width: 100%;
}
</style>
